<div class="sidebar-top">
  <div class="">
    <img src="assets/img/Recruitment_Logo.svg" alt="Recruitment Logo" class="menu-logo img-fluid">
  </div>
</div>
<div class="sidebar">
  <nav style="overflow-y: hidden">
    <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
      <app-menu-item *ngFor="let item of menu" [menuItem]="item"></app-menu-item>
    </ul>
  </nav>
</div>